import { Button, Drawer, Modal, Table, Tooltip, Typography } from "antd";
import axios from "axios";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../../context";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import AddExpense from "./AddExpense";

const DialogExpenseCashCount = ({ open, close, selectedData }) => {
  const { userData } = useContext(UserInfo);
  const [expenseData, setExpenseData] = useState({ data: [], ready: false });
  const [totalAmount, setTotalAmount] = useState(0);
  const tableLayout = "";
  const scroll = {};
  const [openAddExpenseDiag, setOpenAddExpenseDiag] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [dialogData, setDialogData] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);

  const tableProps = {
    bordered: false,
    size: "medium",
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Description",
      dataIndex: "description",
      align: "center",
      render: (text) => (
        <p style={{ minWidth: 80, textAlign: "left" }}>{text}</p>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      align: "center",
      render: (text) => (
        <p style={{ minWidth: 80, textAlign: "right" }}>&#8369;{text}</p>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 40,
      render: (text) => (
        <p
          style={{
            width: 40,
          }}
        >
          <Tooltip title="Delete">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setDialogData(text);
                setDeleteDialog(true);
              }}
              icon={<DeleteOutlined />}
              size="small"
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getExpenseSpecCashCount = useCallback(() => {
    var params = {
      user_id: userData.data.id,
      cash_count_id: selectedData.id,
    };
    axios
      .get("user/merchant-employee/get/cash-count-expense", { params })
      .then((response) => {
        const data = response.data;
        setExpenseData({ data, ready: true });
        setTotalAmount(getTotalAmount(response.data));
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id, selectedData.id]);

  const getTotalAmount = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total += parseInt(data[i].amount) * 1;
    }
    return total;
  };

  useEffect(() => {
    getExpenseSpecCashCount();
  }, [getExpenseSpecCashCount]);

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setDeleteDialog(false);
      setConfirmLoading(false);
      handleDeleteExpense();
    }, 2000);
  };

  const handleDeleteExpense = () => {
    const formdata = new FormData();
    formdata.append("id", dialogData !== null ? dialogData.id : "");

    axios
      .post("user/merchant-employee/delete/cash-count-expense", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Delete product successfully.");
          setTimeout(() => {
            getExpenseSpecCashCount();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  return (
    <Drawer
      title="Expense Details"
      width={window.innerWidth > 600 ? 600 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
      extra={
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ flexGrow: 1 }} />

          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setOpenAddExpenseDiag(true)}
          >
            Add Expense
          </Button>
        </div>
      }
    >
      <div style={{ overflowX: "auto" }}>
        <Table
          {...tableProps}
          pagination={false}
          columns={tableColumns}
          dataSource={expenseData.data.length > 0 ? expenseData.data : []}
          scroll={scroll}
          rowKey={(record) => record.id}
        />
        <div style={{ display: "flex", padding: 15 }}>
          <div style={{ flexGrow: 1 }} />
          <Typography
            style={{ fontWeight: "bold", fontSize: 16, textAlign: "right" }}
          >
            Total Expense: &#8369;
            {totalAmount.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Typography>
        </div>
      </div>

      {openAddExpenseDiag && (
        <AddExpense
          open={openAddExpenseDiag}
          close={() => setOpenAddExpenseDiag(false)}
          rerun={() => getExpenseSpecCashCount()}
          selectedData={selectedData}
        />
      )}

      <Modal
        title="Are you sure to delete this expense record?"
        open={deleteDialog}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setDeleteDialog(false)}
        centered
      />
    </Drawer>
  );
};

export default DialogExpenseCashCount;
